var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 122,
    viewBox: "0 0 147 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--house-1--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M135.507 29.7322H11.4834V121.189H135.507V29.7322Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M145.953 32.311H1.04004L11.8685 36.2528H135.115L145.953 32.311Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M145.97 32.3201H1.03027L10.935 18.0895C11.2235 17.6751 11.6079 17.3365 12.0553 17.1025C12.5027 16.8684 13 16.7458 13.5049 16.7451H133.477C133.984 16.7451 134.483 16.8674 134.932 17.1014C135.381 17.3355 135.767 17.6744 136.057 18.0895L145.97 32.3201Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.8673 5.53271H13.5693V19.3335H23.8673V5.53271Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.8663 5.53271H21.1592V19.3335H23.8663V5.53271Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.5683 1.18848H11.8682V8.28549H25.5683V1.18848Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.5685 1.18848H20.8311V8.28549H25.5685V1.18848Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M43.3745 36.7832H26.4551V63.1135H43.3745V36.7832Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M41.5454 38.4204H28.2842V61.8058H41.5454V38.4204Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M41.5454 38.4204H28.2842V51.2243H41.5454V38.4204Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M37.8871 38.4204H31.9424V51.2243H37.8871V38.4204Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M46.1178 87.5415H23.7109V113.872H46.1178V87.5415Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M43.6954 89.1787H26.1357V112.564H43.6954V89.1787Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M43.6954 89.1787H26.1357V101.983H43.6954V89.1787Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M38.8568 89.1787H30.9824V101.983H38.8568V89.1787Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M122.941 87.5415H100.534V113.872H122.941V87.5415Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M120.519 89.1787H102.959V112.564H120.519V89.1787Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M120.519 89.1787H102.959V101.983H120.519V89.1787Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M115.68 89.1787H107.806V101.983H115.68V89.1787Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M121.112 36.7832H104.192V63.1135H121.112V36.7832Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M119.284 38.4204H106.022V61.8058H119.284V38.4204Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M119.284 38.4204H106.022V51.2243H119.284V38.4204Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M115.625 38.4204H109.681V51.2243H115.625V38.4204Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M78.5843 40.7068H66.7041V59.1901H78.5843V40.7068Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M77.2865 41.8589H67.9854V57.882H77.2865V41.8589Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M77.2865 41.8589H67.9854V50.8399H77.2865V41.8589Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M74.7261 41.8589H70.5557V50.8399H74.7261V41.8589Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M89.5597 80.0332H57.4219V112.5H89.5597V80.0332Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M85.9023 84.6057H61.0811V112.5H85.9023V84.6057Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M68.9823 84.6057H65.6533V112.5H68.9823V84.6057Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M79.957 84.6057H76.6279V112.5H79.957V84.6057Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M62.5806 78.3505H58.7211L73.4913 65.5466L88.2707 78.3505H84.5301V80.4814H95.6695L74.0218 61.742C73.875 61.6134 73.6865 61.5425 73.4913 61.5425C73.2961 61.5425 73.1076 61.6134 72.9609 61.742L51.3223 80.4814H62.5806V78.3505Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M89.7152 112.5H57.4219V115.345H89.7152V112.5Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M89.7152 115.262H57.4219V118.106H89.7152V115.262Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M89.7152 118.024H57.4219V120.868H89.7152V118.024Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M61.081 84.6057H57.8525",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M89.4315 84.6057H86.2031",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleBuilding);
export default __webpack_public_path__ + "static/media/single-building.9254284053ae79f0f8b811f25041a922.svg";
export { ForwardRef as ReactComponent };